import { type MouseEventHandler, useCallback, useEffect } from "react"

import { ComponentProps } from "."
import { Backdrop } from "./styled"

const Overlay = ({
  children,
  className,
  isOpen,
  label,
  onClose
}: ComponentProps) => {
  const handleBackdropClick = useCallback<MouseEventHandler<HTMLDivElement>>(
    (event) => {
      if (event.target !== event.currentTarget) return
      onClose?.()
    },
    [onClose]
  )

  useEffect(() => {
    if (typeof document === "undefined") return undefined
    if (!isOpen) return undefined

    const previousOverflowY = document.body.style.overflowY
    document.body.style.overflowY = "hidden"

    return () => {
      document.body.style.overflowY = previousOverflowY
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <Backdrop
      $isOpen={isOpen}
      aria-label={label}
      aria-modal="true"
      className={className}
      onClick={handleBackdropClick}
      role="dialog"
    >
      {children}
    </Backdrop>
  )
}

export default Overlay
